module.exports = __webpack_public_path__ + "static/media/my.9771c605.svg";